<app-analytics-risk [filters]="filters" [dashboardType]="dashboardType"></app-analytics-risk>
